import { render, staticRenderFns } from "./ManualMatched.vue?vue&type=template&id=2f527ed0"
import script from "./ManualMatched.vue?vue&type=script&lang=js"
export * from "./ManualMatched.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports